import * as React from 'react';
import { connect } from 'react-redux';
import ExecutionEnvironment from 'fbjs/lib/ExecutionEnvironment';
import { getHashValue } from 'utils/urlutils';
import get from 'lodash/get';
import Modal from 'components/Modal/Modal';
import { showModal, hideModal } from 'actions/modalActions';
import LoginSignupView from './LoginSignupView';
import { LoginViews } from './LoginTypes';
import { trackLoginSignupActions } from './LoginSignupAnalytics';
class LoginSignupModal extends React.Component {
    constructor() {
        super(...arguments);
        this.isLoginModalActive = (modal) => {
            if (!modal) {
                return false;
            }
            return modal === LoginViews.LOGIN || modal === LoginViews.SIGNUP || modal === LoginViews.VERIFICATION;
        };
        this.handleLoginModalClose = () => {
            const { modal, loginModalCloseHandler } = this.props;
            const pageType = get(modal, 'modalProps.pageType') || get(this.props, 'pageType', '');
            const loginSource = get(modal, 'modalProps.loginSource') || get(this.props, 'loginSource', '');
            if (typeof loginModalCloseHandler === 'function') {
                loginModalCloseHandler();
            }
            // Fire omniture call.
            trackLoginSignupActions('login_modal_exit', { pageType, loginSource });
            this.props.hideModal();
        };
        this.handleLoginSuccess = () => {
            // Reloads on success to get new session.
            window.location.reload();
        };
    }
    componentDidMount() {
        if (ExecutionEnvironment.canUseDOM) {
            // Shows Login Modal when show_login_modal hash value is present in url.
            const active = Boolean(getHashValue('show_login_modal'));
            active && this.props.showModal(LoginViews.LOGIN);
        }
    }
    render() {
        const { modal } = this.props;
        const modalId = get(modal, 'id', '');
        const pageType = get(modal, 'modalProps.pageType') || get(this.props, 'pageType');
        const loginSource = get(modal, 'modalProps.loginSource') || get(this.props, 'loginSource');
        const modalActive = this.isLoginModalActive(modalId);
        if (!modalActive)
            return null;
        return (<Modal closeOnOverlayClick closeOnEscape closeButton manual active onRequestClose={this.handleLoginModalClose}>
				<LoginSignupView view={modalId} pageType={pageType} loginSource={loginSource} onLoginSuccess={this.handleLoginSuccess}/>
			</Modal>);
    }
}
function mapStateToProps(state) {
    return {
        modal: state.modal
    };
}
const mapDispatchToProps = {
    showModal,
    hideModal
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginSignupModal);
